/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */

import {
  SET_ASSET_SLUG,
} from '../actions/actionTypes'

const initialState = {
  slug: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ASSET_SLUG:
      return {
        slug: action.payload
      }

    default:
      return state;
  }
}